import { ViewStateService } from '../view_state.service';
import { SiteStateService } from '../site_state.service';
import { StartupRegistry } from 'app/startup/registry/registry';

import { ILocalStorageService } from 'angular-local-storage';
import { KMLFeatureLayer } from './kml_feature_layer';

export class KMLFeatureLayerCollection {
    // Only in memory Collection
    private readonly _localCollection: {};

    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $rootScope,
        $interval,
        viewStateService: ViewStateService,
        siteStateService: SiteStateService,
    ) {
        this._localCollection = {};
    }

    get(id): KMLFeatureLayer {
        return this._localCollection[id];
    }

    public add(featureLayer: KMLFeatureLayer) {
        if (!this._localCollection[featureLayer.id]) {
            this._localCollection[featureLayer.id] = featureLayer;
        }
    }
}
